
export default {
  namespaced: true,
  state: {
    confirming: false,
    externalUrl: '',
  },
  getters: {
    confirming: state => state.confirming,
    externalUrl: state => state.externalUrl,
  },
  mutations: {
    setConfirming(state, confirming){
      state.confirming = confirming
    },
    setExternalUrl(state, externalUrl){
      state.externalUrl = externalUrl
    },
  },
  actions: {
    doConfirm(context, externalUrl){
      context.commit("setExternalUrl", externalUrl);
      context.commit("setConfirming", true);
    },
    confirmed(context){
      context.commit("setConfirming", false);
    }
  },
}
